export default __webpack_public_path__ + "static/media/unpaid.455dd3b0.png";